import { render, staticRenderFns } from "./Shipments.vue?vue&type=template&id=2ebb87b7&"
import script from "./Shipments.vue?vue&type=script&lang=js&"
export * from "./Shipments.vue?vue&type=script&lang=js&"
import style0 from "./Shipments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports